export const VIEW_TYPES = {
  TAB_SWITCHER: 'TAB_SWITCHER',
  SEND_SOLUTION: 'SEND_SOLUTION',
  DETAIL_QUOTE: 'DETAIL_QUOTE',
  SOLUTION_FORM: 'SOLUTION_FORM',
  DETAIL_ONE_SOLUTIOM: 'DETAIL_ONE_SOLUTIOM'
};

export type ViewState = {
  itemId: unknown;
  type: string;
  action?: 'approve' | 'reject';
};
